"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToPercent = exports.decimalToPercent = void 0;
const { NumberFormat } = Intl;
function decimalToPercent(locale = 'en', amount, { minimumFractionDigits = 2, maximumFractionDigits = 2 } = {}) {
    const formatOptions = {
        style: 'percent',
        minimumFractionDigits,
        maximumFractionDigits,
    };
    return NumberFormat(locale, formatOptions).format(amount);
}
exports.decimalToPercent = decimalToPercent;
const numberToPercent = (locale = 'en', amount, formatOptions) => decimalToPercent(locale, amount / 100, formatOptions);
exports.numberToPercent = numberToPercent;
//# sourceMappingURL=percentageFormat.js.map